import { Button } from "@aidron/aidron-ds";
import { i18n } from "../../../../translate/i18n";
import { restoreNode, captureNode, prepareNode } from '../utils';

const { t } = i18n;

const handleExportImage = async ({ storeName, currentSupplierName }) => {
    const modalNode = document.getElementById(`supplier-confirmation-modal`);
    if (!modalNode) return;

    const columnsToHide = modalNode.querySelectorAll('.hide-on-export');
    const originalDisplayValues = [];
    const originalStyles = prepareNode(modalNode);

    try {
    columnsToHide.forEach((element, index) => {
        originalDisplayValues[index] = element.style.display;
        element.style.display = 'none';
    });

    await new Promise(resolve => setTimeout(resolve, 100));

    const canvas = await captureNode(modalNode);

    canvas.toBlob((blob) => {
        const fileName = `Loja-${storeName}-Fornecedor-${currentSupplierName}-Data-${new Date().toISOString().slice(0, 10)}.png`;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    });

    } catch (err) {
    console.error("Erro ao exportar imagem:", err);
    alert("Erro ao exportar imagem. Tente novamente.");
    } finally {
    columnsToHide.forEach((element, index) => {
        element.style.display = originalDisplayValues[index];
    });
    restoreNode(modalNode, originalStyles);
    }
};

export const OrderModalBtn = ({ actions, ctx, uiState }) => {

    const { handleEdit, createOrder } = actions || {};
    const { storeName, currentSupplierName } = ctx || {};
    const { cameraIcon } = uiState || {};

    const CameraIconComponent = cameraIcon;

    return (
      <>
        <Button onClick={() => handleExportImage({ storeName, currentSupplierName })} type="ghost" size="sm"> 
          <CameraIconComponent size={33} color="#f97316" />  
        </Button>
        <Button type={'outlined'} onClick={() => handleEdit()} label={'Retornar'} />
        <Button onClick={() => createOrder()} label={t("finalizeOrder")} />
      </>
    );
}